import React from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { DependentOptions } from "../../../../../../../assets/data/projectData";
import { v4 as uuidv4 } from "uuid";

const AddH4 = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        dependent: "",
        documentNumber: "",
        ead: "",
        documentStatus: "",
        dateIssued: "",
        validFrom: "",
        expiryDate: "",
        aNumber: "",
        comments: "",
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        dependent: { type: "select", required: true },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  return (
    <Modal
      title={"ADD H-4 DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="select"
            title={"Dependent"}
            placeholder="Select Dependent"
            value={formData.dependent}
            onChange={(value) => handleChange("dependent", value)}
            error={errors.dependent}
            options={DependentOptions}
            showSearch
          />
          <FormFieldSet
            type="text"
            title={"Document Number"}
            placeholder="Document Number"
            value={formData.documentNumber}
            onChange={(value) => handleChange("documentNumber", value)}
            error={errors.documentNumber}
          />
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            // noTitle={true}
            options={[
              {
                label: "EAD",
                value: true,
              },
            ]}
            values={formData.ead || []}
            onChange={(value) => handleChange("ead", value)}
            multiple
            error={errors.ead}
          />
          <FormFieldSet
            type="select"
            title={"Document Status"}
            placeholder="Select Document Status"
            value={formData.documentStatus}
            onChange={(value) => handleChange("documentStatus", value)}
            error={errors.documentStatus}
          />
          <FormFieldSet
            type="datepicker"
            title={"Date Issued"}
            placeholder="Select Date Issued"
            value={formData.dateIssued}
            onChange={(value) => handleChange("dateIssued", value)}
            error={errors.dateIssued}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Valid From"}
            placeholder="Select Valid From"
            value={formData.validFrom}
            onChange={(value) => handleChange("validFrom", value)}
            error={errors.validFrom}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Expiry Date"}
            placeholder="Select Expiry Date"
            value={formData.expiryDate}
            onChange={(value) => handleChange("expiryDate", value)}
            error={errors.expiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title={"A-Number"}
            placeholder="Enter A-Number"
            value={formData.aNumber}
            onChange={(value) => handleChange("aNumber", value)}
            error={errors.aNumber}
          />
          <FormFieldSet
            type="text"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default AddH4;
